import { MessageSquare } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { GorgiasActionNodeEditor } from "./editor";
import { GorgiasActionNodePanel } from "./panel";

const newNodeDefaultConfig: any = {
  title: {},
  description: {},
};

const newNodeDefaultValue: any = {
  actionType: "create_ticket_on_gorgias",
  config: newNodeDefaultConfig,
};

export default registerNode<any["data"]>({
  type: "action:create_ticket_on_gorgias",
  name: "workflowsEditor.nodes.createGorgiasTicket.title",
  description: "workflowsEditor.nodes.createGorgiasTicket.description",
  Icon: MessageSquare,
  category: NodeCategory.ACTION,
  color: "blue",
  editor: {
    component: GorgiasActionNodeEditor,
  },
  configPanel: {
    component: GorgiasActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export { GorgiasActionNodeEditor } from "./editor";
export { GorgiasActionNodePanel } from "./panel";
